import { useCallback, useState } from 'react';
import useTranslations from '@/hooks/useTranslations';
import { StarButton } from './StarButton';
import useUnfavourite from '@/hooks/carpi/useUnfavourite';
import useFavourite from '@/hooks/useFavourite';
import type { DecisionDialogAnswer } from '@/types/decisionFlow';

interface props {
  title: string;
  subtitle?: string;
  loading?: boolean;
  existingCarpiProductConfigurationId: string;
  hasAlreadyBeenFavourited?: boolean;
  answers?: Record<string, DecisionDialogAnswer>;
}

export default function Favourite({
  loading,
  existingCarpiProductConfigurationId,
  hasAlreadyBeenFavourited,
  answers,
}: props) {
  const { t } = useTranslations();

  const [isFavourite, setIsFavourite] = useState(hasAlreadyBeenFavourited);

  const { handleUnfavouriting } = useUnfavourite(existingCarpiProductConfigurationId);
  const { handleFavouriting } = useFavourite(existingCarpiProductConfigurationId, answers);

  const markAsFavourite = useCallback(async () => {
    if (isFavourite) {
      handleUnfavouriting();
      setIsFavourite(false);
    } else {
      handleFavouriting();
      setIsFavourite(true);
    }
  }, [isFavourite, handleUnfavouriting, handleFavouriting]);

  return (
    <StarButton
      onClick={markAsFavourite}
      leftPosition={false}
      border={true}
      backgroundColor={true}
      isFavourited={isFavourite}
      ariaLabel={t('cards.favourite')}
      disabled={loading}
      smallStar={true}
      text={t('product.workflow.favourite.title')}
    />
  );
}
